import { E_ActionType } from "@backend/graph/patients/patient-base";

type CountryCode = "EN" | "WA" | "NI" | "IE" | "SC" | "CA" | "AU" | "NZ";
type CountryConfig = {
  nhsFormAction?: E_ActionType;
  requireNhsNumber: boolean;
  supportsNhsPr: boolean;
};

const _countryConfig: Partial<Record<CountryCode, CountryConfig>> & Record<"default", CountryConfig> = {
  EN: {
    requireNhsNumber: false,
    supportsNhsPr: true,
    nhsFormAction: E_ActionType.FP17,
  },
  WA: {
    requireNhsNumber: false,
    supportsNhsPr: true,
    nhsFormAction: E_ActionType.FP17,
  },
  SC: {
    requireNhsNumber: false,
    supportsNhsPr: true,
    nhsFormAction: E_ActionType.GP17Part1,
  },
  default: {
    requireNhsNumber: false,
    supportsNhsPr: false,
  },
};

export function getCountryConfig(code: string): CountryConfig {
  return { ..._countryConfig.default, ..._countryConfig[code] };
}
